export const ITEM_TYPES = [
  { value: 'верхняя одежда', label: 'Верхняя одежда' },
  { value: 'верх', label: 'Верх' },
  { value: 'низ', label: 'Низ' },
  { value: 'платье', label: 'Платье' },
  { value: 'обувь', label: 'Обувь' },
  { value: 'аксессуар', label: 'Аксессуар' },
  { value: 'сумка', label: 'Сумка' },
  { value: 'другое', label: 'Другое' },
];

export const SEASONS = [
  { value: 'лето', label: 'Лето' },
  { value: 'зима', label: 'Зима' },
  { value: 'межсезонье', label: 'Межсезонье' },
  { value: 'круглогодичная', label: 'Круглогодичная' },
];
